import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CottageIcon from '@mui/icons-material/Cottage';
import { colors, linkClasses } from '@mui/material';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { buttonClasses } from '@mui/material/Button';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import React from 'react';
export function Breadcrumbs({ dense, children }) {
    return React.createElement(StyledBreadcrumbs, { dense: dense, separator: React.createElement(BreadcrumbSeparator, { fontSize: "small" }) },
        React.createElement(Link, { href: "/" },
            React.createElement(CottageIcon, null)),
        children);
}
const StyledBreadcrumbs = styled(MuiBreadcrumbs, {
    slot: 'Root',
    name: 'Breadcrumbs',
    shouldForwardProp: (propName) => propName !== 'dense'
})(({ theme, dense }) => ({
    '&.MuiBreadcrumbs-root': {
        padding: `${theme.spacing(1)} 0`,
        '& .MuiBreadcrumbs-ol': {
            flexWrap: 'nowrap',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: theme.spacing(0)
        }
    },
    '& .MuiBreadcrumbs-separator': { margin: 0 },
    color: theme.palette.text.primary,
    '& .MuiBreadcrumbs-li': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:last-of-type': {
            [`& .${buttonClasses.root}, .${linkClasses.root}`]: {
                color: theme.palette.text.primary,
            }
        }
    },
    [`& .${buttonClasses.root}, .${linkClasses.root}`]: {
        color: theme.palette.grey['A400'],
        ...(dense ? theme.typography.overline2 : theme.typography.overline),
        padding: 0,
        minWidth: 'auto',
        textDecoration: 'none',
        '& .MuiSvgIcon-root': {
            fontSize: '1rem'
        }
    }
}));
const BreadcrumbSeparator = styled(ArrowForwardIosIcon)(({ theme }) => ({
    padding: 0,
    color: colors.grey[400]
}));
//# sourceMappingURL=Breadcrumbs.js.map